import http, { httpmock } from '@/utils/http';

const endpoint = 'checkin';

export default {
  async post (data) {
    const response = await http.post(`${endpoint}`, { ...data });
    return response.data;
  },
}
